export default __webpack_public_path__ + "static/media/EdMUN.c640695d.svg";